
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/news/author/[...slug]",
      function () {
        return require("private-next-pages/news/author/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/news/author/[...slug]"])
      });
    }
  